module.exports = __webpack_public_path__ + "static/media/julia-icon.65766513.jpg";